import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20modern%20creative%20workspace%20scene%20with%20a%20sleek%20laptop%20on%20a%20light%20oak%20desk%20displaying%20a%20colorful%20organized%20spreadsheet%20interface%2C%20surrounded%20by%20curated%20fashion%20moodboard%20elements%20including%20fabric%20swatches%20in%20warm%20neutral%20tones%2C%20a%20ceramic%20coffee%20cup%2C%20and%20a%20small%20potted%20succulent%2C%20soft%20natural%20morning%20light%20streaming%20through%20large%20windows%20with%20sheer%20white%20curtains%2C%20clean%20Scandinavian%20minimalist%20aesthetic%2C%20cream%20beige%20and%20warm%20sandy%20tones%20throughout%2C%20editorial%20lifestyle%20photography%20with%20organic%20textures%20and%20calm%20productive%20atmosphere&width=1800&height=1200&seq=hero-v2-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion finds and product discovery hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <span className="inline-block px-4 py-1.5 mb-5 text-xs font-semibold tracking-widest uppercase text-background-50/90 bg-primary-500/80 backdrop-blur-sm rounded-full">
          Updated 2026 Guide
        </span>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
          The Ultimate Sugargoo Spreadsheet<br />
          <span className="text-primary-300">Guide &amp; Resource Hub</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover updated Sugargoo Spreadsheet finds, product lists, shopping guides, shipping information, warehouse tips, reviews, coupons and safety strategies — all in one place.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="#what-is"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-background-50/90 text-foreground-900 rounded-full hover:bg-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore the Guide
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          <span className="flex items-center gap-1.5 text-xs text-background-50/70 whitespace-nowrap">
            <i className="ri-check-line text-primary-400"></i>
            Updated Daily Resources
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/70 whitespace-nowrap">
            <i className="ri-check-line text-primary-400"></i>
            Beginner Friendly Guides
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/70 whitespace-nowrap">
            <i className="ri-check-line text-primary-400"></i>
            Community Tested Info
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/70 whitespace-nowrap">
            <i className="ri-check-line text-primary-400"></i>
            Safe Shopping Education
          </span>
        </div>
      </div>
    </section>
  );
}